
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.5","cy":"8.5","r":"7","fill":"#F9CE62"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","d":"M5.7 8.5h5.6"}})])
          )
        }
      }
    